import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ShareIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M24 4a4 4 0 0 1-7.114 2.51l-7.17 3.825a4.987 4.987 0 0 0-.707-1.323l7.17-3.824A4 4 0 1 1 24 4Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM24 20a4 4 0 1 1-7.82-1.188l-7.17-3.824c.297-.399.537-.844.706-1.323l7.17 3.824A4 4 0 0 1 24 20Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M5 17A5 5 0 1 0 5 7a5 5 0 0 0 0 10Zm0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
            })
        ]
    }));
};
